import { trackInteraction } from '@reverbdotcom/commons/dist/tracker';

function init() {
  const trackedClicks = {};
  const badgeSelector = '[data-badge-view]';

  $(badgeSelector).on('click', (event) => {
    const badgeViewName = $(event.target).closest(badgeSelector).data('badge-view');

    if (!trackedClicks[badgeViewName]) {
      trackedClicks[badgeViewName] = true;

      trackInteraction({
        componentName: 'Dashboard',
        type: badgeViewName,
      });
    }
  });
}

$(init);

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/index.js